<div class="columns is-marginless is-centered is-full-height is-vcentered">
    <div class="column is-half">
        <div class="is-size-4 has-text-centered">
            <img src="logo192.png"><br>
            fairball!
        </div>
        <div class="field">
            <p class="control has-icons-left">
                <input class="input" type="email" placeholder="Email" bind:value=username>
                <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                </span>
            </p>
        </div>
        <div class="field is-grouped is-grouped-centered">
            <p class="control">
                <button class="button is-primary {loading ? 'is-loading':''}" on:click="login()">
                    Login
                </button>
            </p>
        </div>
        <div class="notification is-danger {alert ? '': 'is-hidden'}">
            <button class="delete" on:click='set({alert: false})'></button>
            Your username was not recognized.  Perhaps you need to sign up first?
        </div>
    </div>
</div>

<script>
    export default {
        data() {
            return {
                username: "",
                alert: false,
                loading: false
            }
        },
        methods: {
            async login(ev) {
                this.set({loading: true});
                const { username } = this.get();
                const { server } = this.store.get();
                const resp = await fetch(server + '/login?email=' + username);
                const resMsg = await resp.json();
                if (resMsg.success) {
                    this.store.set({ email: username, view: 'verify' });
                } else {
                    // show a message on screen that the something failed
                    this.set({alert: true, loading: false, username: ""});
                }
            }
        }
    };
</script>